import { ZonesAndSubZones } from "../../constants/action-constants/ZonesAndSubZonesActionConstants";

export const getZones = (regionId) => ({
  type: ZonesAndSubZones.GET_ZONES,
  payload: { regionId },
});

export const clearZones = () => ({
  type: ZonesAndSubZones.CLEAR_ZONES,
});

export const createZone = (zoneBean, cityId) => ({
  type: ZonesAndSubZones.CREATE_ZONE,
  payload: { zoneBean, cityId },
});

export const updateZone = (regionId, zoneBean, cityId) => ({
  type: ZonesAndSubZones.UPDATE_ZONE,
  payload: { regionId, zoneBean, cityId },
});

export const deleteZone = (regionId, cityId) => ({
  type: ZonesAndSubZones.DELETE_ZONE,
  payload: { regionId, cityId },
});

export const selectZone = (zone) => ({
  type: ZonesAndSubZones.SELECT_ZONE,
  payload: { zone },
});

export const unSelectZone = (zone) => ({
  type: ZonesAndSubZones.UN_SELECT_ZONE,
  payload: { zone },
});

export const clearSelectedRegionAndZonesMap = () => ({
  type: ZonesAndSubZones.CLEAR_SELECTED_REGION_AND_ZONES_MAP,
});

export const getSubZones = (cityId, zoneId, searchText, pageNo, pageSize) => ({
  type: ZonesAndSubZones.GET_SUB_ZONES,
  payload: { cityId, zoneId, searchText, pageNo, pageSize },
});
export const clearSubZones = () => ({
  type: ZonesAndSubZones.CLEAR_SUB_ZONES,
});

export const createSubZones = (cityId, subZonesBean) => ({
  type: ZonesAndSubZones.CREATE_SUB_ZONES,
  payload: { cityId, subZonesBean },
});

export const updateSubZones = (cityId, subzoneListId, subZonesBean) => ({
  type: ZonesAndSubZones.UPDATE_SUB_ZONES,
  payload: { cityId, subzoneListId, subZonesBean },
});

export const deleteSubZones = (cityId, zoneId, subzoneListId) => ({
  type: ZonesAndSubZones.DELETE_SUB_ZONES,
  payload: { cityId, zoneId, subzoneListId },
});

export const openCreateAndUpdateZoneForm = (isUpdate, zone) => ({
  type: ZonesAndSubZones.OPEN_CREATE_AND_UPDATE_ZONE_MODAL,
  payload: { isUpdate, zone },
});

export const closeCreateAndUpdateZoneForm = () => ({
  type: ZonesAndSubZones.CLOSE_CREATE_AND_UPDATE_ZONE_MODAL,
});

export const openCreateAndUpdateSubZonesForm = (isUpdate) => ({
  type: ZonesAndSubZones.OPEN_CREATE_AND_UPDATE_SUB_ZONES_MODAL,
  payload: { isUpdate },
});

export const closeCreateAndUpdateSubZonesForm = () => ({
  type: ZonesAndSubZones.CLOSE_CREATE_AND_UPDATE_SUB_ZONES_MODAL,
});
